import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MyValuesStartPageRoutingModule } from './my-values-start-routing.module';

import { MyValuesStartPage } from './my-values-start.page';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    MyValuesStartPageRoutingModule
  ],
  declarations: [MyValuesStartPage]
})
export class MyValuesStartPageModule {}
